var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.44 47.27a3 3 0 01-3-3V25.09L.87 5.09a1.52 1.52 0 01-.37-.86V4a3 3 0 013-3h42.09a3 3 0 012.81 3.19c-.02.33-.15.643-.37.89l-17.58 20v14.18a3 3 0 01-1.08 2.31l-6 5a3 3 0 01-1.93.7zM3.91 3.98l17.16 19.55c.24.278.372.633.37 1v19.75l6-5V24.52a1.48 1.48 0 01.38-1L44.99 3.97l-41.08.01z"}));
}

Filter.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = Filter;

Filter.default = Filter;
